module.exports = __webpack_public_path__ + "img/AG.250c090a.svg";